export default __webpack_public_path__ + "static/media/closesvg.35adf4ba.svg";